import queryString from 'query-string'

function isPrintMode(){
  const { print } = queryString.parse(location.search)
  return print === 'true'
}

export default isPrintMode
